import dayjs from 'dayjs';
import {OBJECTION_NODE_ID} from '@/constants/help/index';
import {Inquiry} from '@/api/help/my-inquiry/type';

export const checkIsObjection = (nodeId: string) => {
  return nodeId === OBJECTION_NODE_ID;
};

export const formatCategory = (path: string, nodeId: string) => {
  const category = path.split(' > ')[2];
  if (!category) {
    return '기타';
  }
  if (checkIsObjection(nodeId)) {
    return '이의신청';
  }

  const categoryMap = {
    '1대1문의': '1:1 문의',
    신고하기: '신고하기',
    '불법촬영물등 신고하기': '불법촬영물등신고',
  };

  return categoryMap[category] || category;
};

export const formatMyInquiry = (inquiry: Inquiry, isMobile = false) => {
  const answerStatus = {
    // ASSIGNS: '접수중',
    // ANSWING: '접수중', // 다른 상담사 전달
    ANSWEND: isMobile ? '답변완료' : '완료',
    ANSWTMP: '중간회신',
    ANSWADD: '추가답변',
  };

  const isObjection = checkIsObjection(inquiry.nodeId);
  const category = formatCategory(inquiry.nodePath, inquiry.nodeId);

  return {
    id: inquiry.ticketId,
    // nodeId는 소분류값. 현재 문의/신고/불법 구분값이 없음
    type: category,
    title: inquiry.questionTitle,
    status: answerStatus[inquiry.ticketStatus] || '접수중',
    isEvaluated: inquiry.feedback > -1,
    isAnswered: inquiry.ticketStatus === 'ANSWEND' && !isObjection,
    createdDate: dayjs(inquiry.createdDate).format('YYYY-MM-DD'),
  };
};
